import Container from '../../../atoms/container/listAnimationContainer';
import List from '../list';
import Props from '../../../../../shared/types/props/list';
import { useEffect, useMemo, useState } from 'react';

//---------------------------------------------------------------------.
//  Warning: Note that this list has been designed to work with small  |
//  sets of data. As of now, there is no pagination whatsoever.        |
//  Proceed with caution.                                              |
//---------------------------------------------------------------------·

function AutomatedList(
  props: Props & {
    duration: number;
    index: number;
    offset: number;
    onSetBackgroundIndex: (index: number) => void;
  }
) {
  const {
    children,
    direction,
    duration: originalDuration,
    index: originalIndex,
    onSetBackgroundIndex,
    offset,
  } = props;

  const [duration, setDuration] = useState(originalDuration);
  const [index, setIndex] = useState(originalIndex);

  useEffect(() => {
    if (onSetBackgroundIndex) onSetBackgroundIndex(index);
  }, [index]);

  const data = useMemo(() => {
    return props.children?.length
      ? [...(props.children || []), props.children?.at(0)].map(
          (item, index) => ({ ...item, key: index } as React.ReactNode)
        )
      : props.children;
  }, [children]);

  useEffect(() => {
    setIndex((lastIndex) => {
      if (originalIndex !== 0) {
        // Use original index when iterating throughout the list
        return originalIndex;
      } else {
        if (!lastIndex) {
          // Initialize the index to 0 on the first iteration
          return 0;
        } else {
          // When reaching the end of the list,
          // set the index to be the extra child added previously
          return lastIndex + 1;
        }
      }
    });
  }, [originalIndex]);

  return (
    <Container
      direction={direction}
      duration={duration}
      index={index}
      offset={offset}
      onTransitionEnd={() => {
        if (children?.length && index === children.length) {
          setDuration(0);
          setIndex(0);
          setTimeout(() => {
            setDuration(duration);
          }, 2 * originalDuration * 1000);
        }
      }}
    >
      <List {...props}>{data}</List>
    </Container>
  );
}

export default AutomatedList;
